export interface PricingRules {
  electricityPolicy: ElectricityPolicy;
  petPolicy: PetPolicy;
  petFee?: number;
  depositPercentage: number;
  cleaningFee?: number;
  checkInTime: string;
  checkOutTime: string;
  minStay: number;
  maxStay?: number;
  depositPaymentDays?: number;
}

export type ElectricityPolicy = 'included' | 'metered' | 'flat_fee';

export type PetPolicy = 'not_allowed' | 'allowed_free' | 'allowed_paid_per_day' | 'allowed_paid_per_stay';

export const ELECTRICITY_POLICY_OPTIONS = [
  { value: 'included', labelKey: 'objects.wizard.pricing.electricityOptions.included' },
  { value: 'metered', labelKey: 'objects.wizard.pricing.electricityOptions.metered' },
  { value: 'flat_fee', labelKey: 'objects.wizard.pricing.electricityOptions.flatFee' }
] as const;

export const PET_POLICY_OPTIONS = [
  { value: 'not_allowed', labelKey: 'objects.wizard.pricing.petPolicyOptions.notAllowed' },
  { value: 'allowed_free', labelKey: 'objects.wizard.pricing.petPolicyOptions.allowedFree' },
  { value: 'allowed_paid_per_day', labelKey: 'objects.wizard.pricing.petPolicyOptions.allowedPaidPerDay' },
  { value: 'allowed_paid_per_stay', labelKey: 'objects.wizard.pricing.petPolicyOptions.allowedPaidPerStay' }
] as const;
